import axios from 'axios';
import API_CONFIG from '../config/api';
import { useState, useEffect } from 'react';
// Function to get auth headers with token
const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
};

// Interface for section permissions
interface SectionPermission {
  access: boolean;
}

// Interface for permission template
export interface PermissionTemplate {
  _id: string;
  name: string;
  description?: string;
  userType: string;
  role: string;
  sections: {
    [key: string]: SectionPermission;
  };
}

/**
 * Get all permission templates
 */
export const getPermissionTemplates = async () => {
  try {
    const response = await axios.get(
      API_CONFIG.getUrl('permissions/templates'),
      getAuthHeaders()
    );
    
    return response.data;
  } catch (error) {

    throw error;
  }
};

/**
 * Get permission template by ID
 */
export const getPermissionTemplateById = async (id: string) => {
  try {
    const response = await axios.get(
      API_CONFIG.getUrl(`permissions/${id}`),
      getAuthHeaders()
    );
    
    return response.data;
  } catch (error) {

    throw error;
  }
};

/**
 * Get permission template by role
 */
export const getPermissionTemplateByRole = async (role: string) => {
  try {
    const response = await axios.get(
      API_CONFIG.getUrl(`permissions/role/${role}`),
      getAuthHeaders()
    );
    
    return response.data;
  } catch (error) {

    throw error;
  }
};

/**
 * Update permission template
 */
export const updatePermissionTemplate = async (id: string, template: PermissionTemplate) => {
  try {
    const response = await axios.put(
      API_CONFIG.getUrl(`permissions/${id}`),
      template,
      getAuthHeaders()
    );
    
    return response.data;
  } catch (error) {

    throw error;
  }
};

/**
 * Initialize default permissions (SuperAdmin only)
 */
export const initializeDefaultPermissions = async () => {
  try {
    const response = await axios.post(
      API_CONFIG.getUrl('permissions/initialize'),
      {},
      getAuthHeaders()
    );
    
    return response.data;
  } catch (error) {

    throw error;
  }
};

/**
 * React hook to load permission template for a given role
 */
export const usePermissionTemplates = (role: string) => {
  const [template, setTemplate] = useState<PermissionTemplate | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (!role) return;
    setLoading(true);
    getPermissionTemplateByRole(role)
      .then((data) => setTemplate(data))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [role]);

  return [template, loading, error] as const;
};